// Core
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

//Toast
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//Router
import { BrowserRouter } from "react-router-dom";

//Custom routes
import RootRoutes from "Routes/RootRoutes";

// Page
import NoInternet from "Pages/Common/NoInternet";

const AppRoutes = () => {
  // Local states
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [lastPath, setLastPath] = useState("/");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      navigate("/pre-assessment");
      toast.success("You're back online. All your answers are saved. You can continue.");
    };

    const handleOffline = () => {
      setIsOnline(false);
      if (location.pathname !== "/no-internet") {
        // setLastPath(location.pathname); // Save the current path
        navigate("/no-internet"); // Navigate to the No Internet page
      }
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, [location.pathname, navigate, lastPath]);

  useEffect(() => {
    if (navigator.onLine) {
      if (location.pathname === "/no-internet") {
        navigate("/pre-assessment");
        toast.success("You're back online. All your answers are saved. You can continue.");
      }
    }
    const timer = setTimeout(() => setLoading(false), 200);
    return () => clearTimeout(timer);
  }, [navigate, location.pathname]);


  if (loading) return null;

  // Conditionally render the No Internet page if offline
  if (!isOnline) {
    return <NoInternet />;
  }

  return <RootRoutes />; // Render your main routes when online
};

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
      <ToastContainer
        position="top-right" // Position of the toast
        autoClose={4000} // Auto-close the toast after 4 seconds
        hideProgressBar={false} // Show or hide the progress bar
        newestOnTop={false} // Display new toasts on top
        closeOnClick // Close the toast when clicked
        rtl={false} // Right-to-left layout support
        pauseOnFocusLoss={false} // Pause toast when window is not focused
        draggable={false} // Allow the toast to be draggable
        pauseOnHover={false} // Pause toast on hover
        theme="light" // Light or dark theme
      />
    </BrowserRouter>
  );
}

export default App;
